import apiClient from "./client";

export const websiteApi = {
  getDraft: async () => {
    const response = await apiClient.get("/website/draft");
    return response.data;
  },
  saveDraft: async (data) => {
    const response = await apiClient.put("/website/draft", { data });
    return response.data;
  },
  deleteDraft: async () => {
    const response = await apiClient.delete("/website/draft");
    return response.data;
  },
  getPublicPackages: async () => {
    const response = await apiClient.get("/website/packages/public");
    return response.data;
  },
  getAdminPackages: async () => {
    const response = await apiClient.get("/website/admin/packages");
    return response.data;
  },
  getAdminRequests: async () => {
    const response = await apiClient.get("/website/admin/requests");
    return response.data;
  },
  getAdminRequest: async (id) => {
    const response = await apiClient.get(`/website/admin/requests/${id}`);
    return response.data;
  },
  deleteAdminRequest: async (id) => {
    const response = await apiClient.delete(`/website/admin/requests/${id}`);
    return response.data;
  },
  createPackage: async (data) => {
    const response = await apiClient.post("/website/admin/packages", data);
    return response.data;
  },
  updatePackage: async (id, data) => {
    const response = await apiClient.put(`/website/admin/packages/${id}`, data);
    return response.data;
  },
  deletePackage: async (id) => {
    const response = await apiClient.delete(`/website/admin/packages/${id}`);
    return response.data;
  },
  getOnboardingQuestions: async () => {
    const response = await apiClient.get("/website/onboarding/questions");
    return response.data;
  },
  getOnboardingSteps: async () => {
    const response = await apiClient.get("/website/onboarding/steps");
    return response.data;
  },
  getOnboardingConfig: async () => {
    const response = await apiClient.get("/website/onboarding/config");
    return response.data;
  },
  checkDomainAvailability: async (domain) => {
    const response = await apiClient.get(
      `/website/onboarding/domain-check/${encodeURIComponent(domain)}`,
    );
    return response.data;
  },
  getAdminOnboardingConfig: async () => {
    const response = await apiClient.get("/website/admin/onboarding/config");
    return response.data;
  },
  getContractSettings: async () => {
    const response = await apiClient.get("/onboarding/contract-settings");
    return response.data;
  },
  saveOnboardingSteps: async (steps) => {
    const response = await apiClient.put("/website/admin/onboarding/steps", {
      steps,
    });
    return response.data;
  },
  saveOnboardingConfig: async (config) => {
    const response = await apiClient.put(
      "/website/admin/onboarding/config",
      config,
    );
    return response.data;
  },
  saveOnboardingQuestions: async (questions) => {
    const response = await apiClient.put("/website/admin/onboarding/questions", {
      questions,
    });
    return response.data;
  },
  createRequest: async (data) => {
    const response = await apiClient.post("/website/requests", data);
    return response.data;
  },
  getClientRequests: async () => {
    const response = await apiClient.get("/website/requests");
    return response.data;
  },
  getClientRequest: async (id) => {
    const response = await apiClient.get(`/website/requests/${id}`);
    return response.data;
  },
  updateRequestStatus: async (id, status) => {
    const response = await apiClient.put(
      `/website/admin/requests/${id}/status`,
      { status },
    );
    return response.data;
  },
  setRequestQuote: async (id, amount) => {
    const response = await apiClient.put(
      `/website/admin/requests/${id}/quote`,
      { amount },
    );
    return response.data;
  },
};
